export const AIAssistantEventType = {
  AI_MESSAGE: "AI_MESSAGE",
  ASSISTANT_TASK_STATUS: "AssistantTaskStatus",
};
